import React from 'react';
import { inject, observer } from 'mobx-react';
import { Typography, Button, Space } from 'antd';

const { Text } = Typography;

export const TopBar = inject('currentUserStore')(observer(({ currentUserStore, style }) => {
    return (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', height: '100%', ...style }}>
            {currentUserStore.isAuthenticated && (
                <Space>
                    <Text style={{ color: 'rgba(255,255,255,0.55)' }}>
                        {currentUserStore.user?.displayName || currentUserStore.user?.email}
                    </Text>
                    <Button
                        size="small"
                        onClick={currentUserStore.logout}
                        style={{ borderColor: 'rgba(255,255,255,0.2)', color: 'rgba(255,255,255,0.7)' }}
                    >
                        Log Out
                    </Button>
                </Space>
            )}
        </div>
    );
}));
